import { ContactsPage, MetaData } from '@/components'

export default function NextContactsPage(props) {
  const { meta } = props;
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || "ELEMENTAL Day Surgical Center Contacts";
  const description = descFromProps || "ELEMENTAL Day Surgical Center"

  return (
    <>
      <MetaData title={title} description={description}  />
      <ContactsPage {...props} />
    </>
  )
}

NextContactsPage.getInitialProps = async ({api}) => {
  const response = await api.contacts()
  return { ...response, pageType:'contacts' }
}
